import {React, useEffect } from 'react'
import { useNavigate  } from 'react-router-dom'
import UserStore from '../../store/slice/user.slice'


function Logout(){
    
    const navigate =  useNavigate()

    const sessionExpire = () => {
        localStorage.removeItem('brCode')
        localStorage.removeItem('userDetails')
        localStorage.removeItem('brName')
        localStorage.removeItem('auth_token')
        localStorage.clear()
        UserStore.getState().reset()
    }

    sessionExpire()

    useEffect(()=>{
        navigate('/auth/signin')
    },[navigate])

    return(
        <div></div>
    )
    
}

export default Logout